<template>
    <intranet-nav-content>
        <template slot="links">
            <intranet-nav-content-link-exact :link="{ name: 'Proceso del programa 2023-2024', path: { name: 'admin-general-process' } }"/>
        </template>
    </intranet-nav-content>
</template>

<script>
import IntranetNavContent from '@/layout/NavContent/IntranetNavContent';
import IntranetNavContentLinkExact from '@/layout/NavContent/IntranetNavContentLinkExact';

export default {
    name: 'Documents',
    components: { 
        IntranetNavContent,
        IntranetNavContentLinkExact,
    },
};
</script>
